<div class="animate-pulse">
  <div class="flex items-center justify-between border-y py-3 mb-6">
    <div class="inline-flex items-center rounded-[8px] font-medium space-x-2">
      <div class="h-10 bg-gray-100 rounded w-24"></div>
      <div class="h-10 bg-gray-100 rounded w-24"></div>
      <div class="h-10 bg-gray-100 rounded w-24"></div>
    </div>

    <div class="flex items-center space-x-2">
      <div class="h-10 bg-gray-100 w-[400px] rounded"></div>
      <div class="h-10 bg-gray-100 w-24 rounded"></div>
    </div>
  </div>
  <div class="overflow-x-auto">
    <table class="w-full text-sm">
      <thead>
        <tr>
          <th class="font-normal text-left py-3 border-b">
            <div class="h-4 bg-gray-100 rounded w-32"></div>
          </th>
          <th class="font-normal text-left py-3 border-b">
            <div class="h-4 bg-gray-100 rounded w-32"></div>
          </th>
          <th class="font-normal text-left py-3 border-b">
            <div class="h-4 bg-gray-100 rounded w-32"></div>
          </th>
          <th class="text-left py-3 border-b">
            <div class="h-4 bg-gray-100 rounded w-8"></div>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (row of [1, 2, 3, 4, 5]; track row) {
          <tr>
            <td class="py-4 border-b">
              <div class="h-6 bg-gray-100 rounded w-24"></div>
            </td>
            <td class="py-4 border-b">
              <div class="h-6 bg-gray-100 rounded w-24"></div>
            </td>
            <td class="py-4 border-b">
              <div class="h-6 bg-gray-100 rounded w-24"></div>
            </td>
            <td class="py-4 border-b">
              <div class="h-6 bg-gray-100 rounded w-24"></div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
